import { useEffect } from "react";
import styles from "./styles/GamePlay.module.css";
import PlayWire from "../../components/PlayWire";
import {
  ADS_PROVIDER_YANDEX,
  ADS_PROVIDER_ADSENSE,
  ADS_PROVIDER_PLAYWIRE,
  useSiteData,
} from "../../ducks/siteData";
import AdSense from "../../components/AdSense";
import StickyAdsenseAd from "../../components/StickyAdsenseAd";

const pwUnits = [
  {
    selectorId: "game_skyscraper_desktop",
    type: "sky_atf",
  },
];

const pwUnitsMobile = [
  {
    selectorId: "game_sticky_bottom_mobile",
    type: "leaderboard_btf",
  },
];

async function initPlayWire(isDesktop: boolean) {
  if (window.ramp) {
    const units = isDesktop ? pwUnits : pwUnitsMobile;
    try {
      await window.ramp.destroyUnits("all");
      await window.ramp.addUnits(units);
      await window.ramp.displayUnits();
    } catch (error) {
      console.log(error);
    }
  }
}

// function initPlayWire(isDesktop: boolean) {
//   if (window.ramp) {
//     try {
//       window.ramp.que.push(function () {
//         window.ramp.addTag(isDesktop ? "pwDeskSkyAtf" : "pwMobiLbAtf");
//       });
//     } catch (error) {
//       console.log(error);
//     }
//   }
// }

function initYandex(isDesktop) {
  const obj = isDesktop
    ? {
        renderTo: "yandex_rtb_R-A-1674804-1",
        blockId: "R-A-1674804-1",
      }
    : {
        renderTo: "yandex_rtb_R-A-1674804-3",
        blockId: "R-A-1674804-3",
      };

  window.yaContextCb.push(() => {
    window.Ya.Context.AdvManager.render(obj);
  });
}

export default function GameAd({ isDesktop }) {
  const { adsVisible, adsProvider } = useSiteData();

  // return (
  //   <div className=" w-[160px] xl:w-[300px] h-[600px] bg-green-700 mr-4 min-w-[160px]"></div>
  // );

  useEffect(() => {
    if (!adsVisible || isDesktop === null) {
      return;
    }

    if (adsProvider === ADS_PROVIDER_PLAYWIRE) {
      setTimeout(() => {
        initPlayWire(isDesktop);
      }, 3000);
    } else if (adsProvider === ADS_PROVIDER_YANDEX) {
      initYandex(isDesktop);
    }
  }, [adsVisible, isDesktop]);

  // if (!adsVisible || isDesktop === null) {
  //   return <div className=" w-[160px] h-[600px] mr-4 min-w-[160px]"></div>;
  // }

  switch (adsProvider) {
    case ADS_PROVIDER_ADSENSE:
      return isDesktop ? (
        <AdSense
          adStyles={styles.pwAd}
          showRemoveAds={false}
          slot="7152821243"
          format="auto"
          insStyle={{ width: "160px" }}
        />
      ) : (
        <StickyAdsenseAd />
      );
    case ADS_PROVIDER_PLAYWIRE:
      return isDesktop ? (
        <PlayWire
          id="game_skyscraper_desktop"
          contStyles="h-[600px] w-[160px] md:mr-5"
          className={styles.pwAd}
        />
      ) : (
        <PlayWire
          contStyles="fixed w-full z-10 bottom-0"
          id="game_sticky_bottom_mobile"
          className="flex items-center"
        />
      );

    case ADS_PROVIDER_YANDEX:
      return isDesktop ? (
        <div className={styles.pwAd} id="yandex_rtb_R-A-1674804-1"></div>
      ) : (
        <div
          className="fixed flex items-center bottom-0 z-10 w-full max-h-[100px]"
          id="yandex_rtb_R-A-1674804-3"
        ></div>
      );
    default:
      // return null;
      return <div className="md:w-[160px] md:h-[600px] md:mr-5"></div>;
  }
}
